import { InjectionToken, Provider } from "@angular/core";

import { GRPCEnvironment } from "../class/environment.class";

export const GRPC_ENVIRONMENT = new InjectionToken<GRPCEnvironment>(
  "GRPC_ENVIRONMENT"
);

export const GRPCEnvironmentProvider: Provider = {
  provide: GRPC_ENVIRONMENT,
  useValue: new GRPCEnvironment(),
};
